import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { LangProvider } from "@/i18n";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Products from "@/components/landing/Products";
import PhotoStrip from "@/components/landing/PhotoStrip";
import Process from "@/components/landing/Process";
import Quality from "@/components/landing/Quality";
import Community from "@/components/landing/Community";
import Videos from "@/components/landing/Videos";
import Impact from "@/components/landing/Impact";
import Gallery from "@/components/landing/Gallery";
import Enquiry from "@/components/landing/Enquiry";
import Footer from "@/components/landing/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangProvider>
      <div className="bg-cream text-ink font-sans antialiased overflow-x-clip" data-testid="app-root">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Products />
        <PhotoStrip />
        <Process />
        <Quality />
        <Community />
        <Videos />
        <Impact />
        <Gallery />
        <Enquiry />
      </main>
      <Footer />
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#1A1D1A", color: "#FDFBF7", border: "1px solid #4A5240" } }} />
      </div>
    </LangProvider>
  );
}
